import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VisitorEntities, VisitorModel } from 'client/data/models/visitor';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { FeaturesSpecsParams } from 'site-modules/shared/utils/features-specs/params';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';
import { Link } from 'site-modules/shared/components/link/link';
import { AnimatedSticky } from 'site-modules/shared/components/animated-sticky/animated-sticky';
import { InventoryButton } from 'site-modules/shared/components/inventory-button/inventory-button';

import './more-about-mmy-link.scss';

function MoreAboutMMYLinkUI({
  vehicle,
  className,
  linkClassName,
  iconClassName,
  dataTrackingId,
  dataTrackingValue,
  linkToReview,
  showBuyOnlineBtn,
  isMobile,
  params,
  visitorLocation,
}) {
  const {
    make: { slug: makeSlug },
    model: { name: modelName, slug: modelSlug },
    year,
  } = vehicle;

  const linkUrl = getCoreUrl({ makeSlug, modelSlug, year }, linkToReview);

  const linkFragment = (
    <Link
      className={classnames('link d-inline-block', linkClassName)}
      to={linkUrl}
      data-tracking-id={dataTrackingId}
      data-tracking-value={dataTrackingValue}
      data-test="more-about-mmy-link"
    >
      More about the {year} {modelName}
      <i className={classnames('d-inline-block ms-0_25 icon-arrow-right4 size-10', iconClassName)} aria-hidden />
    </Link>
  );
  const stickyFragment = (
    <Fragment>
      {linkFragment}
      {showBuyOnlineBtn && (
        <div className="button-container">
          {!isMobile && (
            <InventoryButton params={params} makeModelSubmodelYear={vehicle} visitorLocation={visitorLocation} />
          )}
          <InventoryButton
            params={params}
            makeModelSubmodelYear={vehicle}
            visitorLocation={visitorLocation}
            isBuyOnline
          />
        </div>
      )}
    </Fragment>
  );

  return (
    <AnimatedSticky
      identifierClass="more-about-mmy-link"
      className={classnames('sticky-mmy-link', className)}
      stickyClassName={classnames('d-flex align-items-center justify-content-between', {
        'py-1': !showBuyOnlineBtn,
        'py-0_5': showBuyOnlineBtn,
      })}
      stickyFragment={stickyFragment}
    >
      {linkFragment}
    </AnimatedSticky>
  );
}

MoreAboutMMYLinkUI.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  className: PropTypes.string,
  linkClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  dataTrackingId: PropTypes.string,
  dataTrackingValue: PropTypes.string,
  linkToReview: PropTypes.bool,
  showBuyOnlineBtn: PropTypes.bool,
  isMobile: PropTypes.bool,
  params: FeaturesSpecsParams,
  visitorLocation: VisitorEntities.Location,
};

MoreAboutMMYLinkUI.defaultProps = {
  className: null,
  linkClassName: 'my-1',
  iconClassName: 'text-primary-darker',
  dataTrackingId: null,
  dataTrackingValue: null,
  linkToReview: false,
  showBuyOnlineBtn: false,
  isMobile: false,
  params: null,
  visitorLocation: null,
};

export const MoreAboutMMYLink = connectToModel(MoreAboutMMYLinkUI, {
  visitorLocation: bindToPath('location', VisitorModel),
});
